/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type Language = typeof Language[keyof typeof Language];


export const Language = {
  ca: 'ca',
  cs: 'cs',
  da: 'da',
  nl: 'nl',
  en: 'en',
  fr: 'fr',
  de: 'de',
  el: 'el',
  hu: 'hu',
  it: 'it',
  pl: 'pl',
  pt: 'pt',
  es: 'es',
  hr: 'hr',
} as const;
